<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M5.667 4a1 1 0 011-1h12a1 1 0 01.707.293L26.04 9.96a1 1 0 01.293.707V28a1 1 0 01-1 1H6.667a1 1 0 01-1-1V4zm2 1v22h16.666V11.667h-5.666a1 1 0 01-1-1V5h-10zm12 1.414l3.252 3.253h-3.253V6.414zM12 21.667a1 1 0 000 2h8a1 1 0 100-2h-8zm-1-4.334a1 1 0 011-1h8a1 1 0 110 2h-8a1 1 0 01-1-1zM12 11a1 1 0 000 2h2.666a1 1 0 100-2H12z"/></svg>